/**
 * domain base
 *
 * @author Shigq
 * @date 2021/6/3 14:17
 */
import { validatorComp, commonComp, fileComp } from '@/compositions'
import { useI18n } from '@/plugins/i18n'

const { t } = useI18n()
const { constant: { RSP_ITEM_TYPE, REQ_ITEM_TYPE, FILE } } = commonComp()

export {
  t,
  validatorComp,
  fileComp,
  RSP_ITEM_TYPE,
  REQ_ITEM_TYPE,
  FILE
}
